import React from 'react';
import RIEBase from 'components/core/editable/RIEBase';
import ProcessUtils from 'utils/ProcessUtils';
import DatePicker from 'react-datepicker';
import { css } from 'emotion';
import { Button } from 'antd';
import ReactDOM from 'react-dom';

/**
 * Date picker component. Allows user input of "ANY_TIME"
 */
export default class RIEDatePicker extends RIEBase {

    elementBlur = (e) => {
        //TODO: settimeout is not the best way to do this there is probably another way like how e.relatedTarget
        setTimeout(() => {
            const componentArea = ReactDOM.findDOMNode(this.refs.container);
            const clickedElement = e.relatedTarget || document.activeElement;
            if (componentArea) {
                if (!componentArea.contains(clickedElement)) {
                    this.finishEditing();
                }
            }
        }, 300);
    };

    handleChange = (date) => {
        let newValue = date;
        if (date !== null) {
            if (date !== 'ANY_TIME') {
                newValue = ProcessUtils.momentToEpoch(date);
            }
            this.setState({ newValue });
        }
    };

    handleChangeRaw = (e) => {
        let value = e.target.value;
        value = value.toLowerCase();
        if (value === 'any time' || value === 'any_time') {
            const newValue = 'ANY_TIME';
            this.setState({ newValue });
        }
    };

    handleAnytimeClick = () => {
        const input = document.getElementById(`datepicker-${this.props.fieldPath}`);
        input.value = 'Any time';

        const newValue = 'ANY_TIME';
        this.setState({ newValue });
        this._calendar.setOpen(false);
    };

    componentDidUpdate = () => {
        const value = this.getNewValue();
        const input = document.getElementById(`datepicker-${this.props.fieldPath}`);

        if (value === 'ANY_TIME') {
            if (input !== null) {
                input.value = 'Any time';
            }
        }
    };

    getMinWidth = () => {
        return '225px';
    };

    renderEditingComponent = () => {
        let value = this.getNewValue();
        if (value === 'ANY_TIME') {
            value = null;
        } else {
            value = ProcessUtils.epochToMoment(value);
        }
        return (
            <DatePicker
                id={`datepicker-${this.props.fieldPath}`}
                dateFormat={['YYYY-MM-DD', 'YYYYMMDD', 'YYYY/MM/DD']}
                selected={value}
                onChange={this.handleChange}
                onChangeRaw={this.handleChangeRaw}
                onBlur={this.elementBlur}
                showYearDropdown
                showMonthDropdown
                disabledKeyboardNavigation
                dropdownMode="select"
                autoFocus
                onClickOutside={this.handleClickOutside}
                ref={(c) => this._calendar = c}
                popperPlacement={'bottom-right'}
                popperModifiers={{ flip: { enabled: false } }}
            >
                <div className={css`padding: 5px 40px;`}>
                    <Button
                        size="small"
                        onClick={this.handleAnytimeClick}
                        className={css`with:100%;`}
                    >
                        Any time
                    </Button>
                </div>
            </DatePicker>
        );
    };

    renderReadComponent = () => {
        let value = this.getNewValue();
        value = ProcessUtils.getTimeDisplayText(value);
        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (<span
            tabIndex="0"
            className={this.makeClassString()}
            onClick={this.startEditing}
            {...this.props.defaultProps}
        >{value}</span>);
    };
}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIEDatePicker.js